import { HomeContent } from './../models/home.model';
import { Component } from "@angular/core";

@Component({
  selector : 'app-home',
  templateUrl : './../views/home.component.html',
  styleUrls : ['./../css/home.component.css']
})

export class HomeComponent
{
 public msn:HomeContent;


 constructor(){
  this.msn = new HomeContent("Bienvenido a Su Gestor de Pacientes", "Gestione Sus pacientes de Forma Sencilla");
 }

 ngOnInit(): void {
   //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
   //Add 'implements OnInit' to the class.

 }

}
/*********************************************************************************************************************
 Construido y distribuido por IT-SolutionsSpa, soluciones informáticas para su negocio 
Santiago, Chile 2019,
Ingeniero de Software FrontEnd: Rodrigo Neira
Ingeniero de Software BackEnd: Octavio Cubillos
Gestor: Edison Núñez
mayor informacion a contacto@itsolutonsspa.cl
o en www.itsolutionsspa.cl 
 ********************************************************************************************************************/